export const ruRU = {
  // Депозит
  deposit: {
    title: 'Депозит',
    chain: 'Сеть',
    asset: 'Актив',
    amount: 'Сумма',
    available: 'Доступно',
    equity: 'Капитал',
    confirmDeposit: 'Подтвердить депозит',
    switchNetwork: 'Сменить сеть',
    max: 'Максимум',
    arrivalTime: 'Время поступления',
    minDeposit: 'Минимальная сумма депозита',
    minDepositParsed: 'Мин. депозит {{amount}} {{token}}',
    maxDeposit: 'Максимальная сумма депозита',
    depositTipFor25w:
      'Максимальная сумма одного пополнения — 200 000. Если сумма превышает 200 000, пожалуйста, используйте сеть Ethereum для пополнения.',
    depositAllTip:
      'На этот адрес можно внести только {{coin}} ({{v}}). \n Если сумма депозита превышает 200 000, время поступления может быть увеличено. Пожалуйста, ожидайте.',
    enableSystemProWithToken: 'Включить {{token}} в сети {{network}}',
    enableTokenDesc:
      'При первом депозите в сети {{network}} необходимо включить {{token}}.',
    enableWithToken: 'Включить {{token}}',
    arrivaltimeTooltip1:
      'Средства поступят в течение примерно {{v}} минут (после достижения {{v1}} подтверждений блоков).',
    arrivaltimeTooltip2:
      'Оценка времени основана на истории и дана только для справки. Задержки сети могут увеличить фактическое время поступления.',
    arrivalEstimated: '≈ {{v}} минут',
    availableDesc:
      'Максимальная сумма, которую вы можете пополнить. Если доступный баланс равен 0 или отрицательный, пополнение невозможно.',
    noPrivateKeyWalletWarning:
      'Не используйте кошельки без приватных ключей для пополнения. Пополнение с такого кошелька может привести к безвозвратной потере средств.',
    layerZeroDepositTip:
      'Система завершит ваше пополнение через LayerZero в зависимости от фактических условий депозита.',
    layerZeroDepositTipExceedPool:
      'Поскольку сумма пополнения превышает пул, ваше пополнение будет выполнено через LayerZero.',
    layerZeroDepositTipGte200k:
      'Поскольку сумма пополнения больше либо равна 200,000 USDT, ваше пополнение будет выполнено через LayerZero.',
    layerZeroDepositButton: 'Пополнение через LayerZero',
  },
  withdraw: {
    noticeDesc:
      'Вывод средств происходит в два этапа: сначала подаётся заявка на вывод (обрабатывается на Layer 2), затем - перевод на кошелёк после подготовки средств (до 14 часов). Из-за синхронизации цепочки и других факторов процесс может занять до 48 часов. За gas-комиссии отвечает пользователь.',
    crossChainTips:
      '• Кроссчейн выводы требуют проверки на L2 (через ZK доказательства) и могут занять до 2 часов. Для вывода нужны средства в пуле соответствующей цепи. Также взимается комиссия за газ. edgeX взимает плату за обслуживание.',
    commonWithdraw: 'Часто задаваемые вопросы по выводу',
    withdraw: 'Вывод',
    speed: 'Скорость',
    confirmWithdraw: 'Подтвердить вывод',
    speedNote: 'Время обработки:',
    speedNoteSpeed1: 'Прибл. 8 минут',
    speedNoteSpeed2: 'Прибл. 2-4 часа',
    speedNoteSpeed3: 'Прибл. 4 часа',
    receiverAddress: 'Адрес получателя',
    fee: 'Комиссия',
    feeRate: 'Тариф',
    withdrawlAmount: 'Сумма вывода',
    amountToReceive: 'Сумма к получению',
    invalidReceiverAddress: 'Укажите адрес кошелька',
    availableDesc:
      'Максимальная сумма, которую вы можете вывести. Если доступный баланс равен 0 или отрицательный, вывод средств невозможен.',

    feeCalculationTip:
      'Комиссия за вывод средств рассчитывается путем умножения суммы вывода на ставку комиссии, минимальная комиссия составляет 1 USDT/USDC. Ставка комиссии может быть скорректирована в зависимости от фактической ситуации в сети блокчейн.',
    crossChainPoolBalance: 'Баланс кросс-чейн пула',
    poolBalance: 'Баланс пула',
    poolBalanceInsufficientTip:
      'Сумма вывода превышает баланс пула средств, и операция не может быть выполнена. Пожалуйста, выберите опцию с достаточным балансом пула средств.',
  },
  account: {
    title: 'Аккаунт',
    perpetual: 'Перпетуальный счет',
    spot: 'Спотовый счет',
  },
}

export default ruRU
